// Normalises legacy/inconsistent campaign status strings to the canonical
// ARC lifecycle stages used across the app.
export function normaliseCampaignStatus(status) {
  if (status === 'draft') return 'note_interest';
  if (status === 'open') return 'active';
  return status || 'note_interest';
}

// Stages where readers can apply / register interest / receive ARCs.
// Excludes 'closed' and 'archived' — those should not appear in the
// reader-facing apply flow.
export const ACTIVE_CAMPAIGN_STATUSES = ['note_interest', 'active', 'live'];
